// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3QfmV","col":"Table_col__3lzB8","fulfillmentStatus":"Table_fulfillmentStatus__2FMgw","emailCol":"Table_emailCol__20IkP"};